// Approximate centroids (lat, lng) for French départements.
// Used to plot markers when an event has no precise lat/lng coordinates yet.
// Accurate to within ~30km of the geographic center of each département.
// Source: derived from national open-data centroids, rounded.
export const DEPT_CENTROIDS = {
  '01': [46.10, 5.35], '02': [49.55, 3.55], '03': [46.50, 3.20], '04': [44.10, 6.25],
  '05': [44.65, 6.10], '06': [43.95, 7.10], '07': [44.75, 4.40], '08': [49.65, 4.65],
  '09': [42.95, 1.45], '10': [48.30, 4.10], '11': [43.05, 2.40], '12': [44.30, 2.60],
  '13': [43.55, 5.10], '14': [49.10, -0.35], '15': [45.05, 2.65], '16': [45.70, 0.20],
  '17': [45.80, -0.65], '18': [47.05, 2.50], '19': [45.35, 1.85], '21': [47.40, 4.75],
  '22': [48.45, -2.80], '23': [46.10, 2.05], '24': [45.10, 0.75], '25': [47.20, 6.30],
  '26': [44.70, 5.10], '27': [49.10, 0.90], '28': [48.30, 1.30], '29': [48.30, -4.00],
  '2A': [41.85, 8.95], '2B': [42.40, 9.20], '30': [44.05, 4.25], '31': [43.40, 1.40],
  '32': [43.65, 0.45], '33': [44.85, -0.65], '34': [43.60, 3.40], '35': [48.15, -1.70],
  '36': [46.75, 1.55], '37': [47.25, 0.70], '38': [45.30, 5.55], '39': [46.70, 5.65],
  '40': [43.85, -0.65], '41': [47.60, 1.40], '42': [45.65, 4.30], '43': [45.10, 3.80],
  '44': [47.30, -1.55], '45': [47.90, 2.20], '46': [44.65, 1.65], '47': [44.35, 0.55],
  '48': [44.55, 3.50], '49': [47.40, -0.55], '50': [49.10, -1.30], '51': [49.00, 4.15],
  '52': [48.10, 5.20], '53': [48.10, -0.65], '54': [48.80, 6.15], '55': [48.95, 5.40],
  '56': [47.85, -2.80], '57': [49.05, 6.65], '58': [47.10, 3.55], '59': [50.45, 3.25],
  '60': [49.45, 2.40], '61': [48.65, 0.05], '62': [50.50, 2.25], '63': [45.75, 3.15],
  '64': [43.25, -0.75], '65': [43.05, 0.15], '66': [42.55, 2.55], '67': [48.60, 7.65],
  '68': [47.95, 7.30], '69': [45.85, 4.70], '70': [47.65, 6.20], '71': [46.65, 4.55],
  '72': [48.00, 0.20], '73': [45.55, 6.45], '74': [46.05, 6.50], '75': [48.85, 2.35],
  '76': [49.65, 1.10], '77': [48.65, 3.05], '78': [48.85, 1.90], '79': [46.55, -0.30],
  '80': [49.95, 2.30], '81': [43.85, 2.25], '82': [44.05, 1.30], '83': [43.50, 6.15],
  '84': [44.00, 5.10], '85': [46.65, -1.40], '86': [46.55, 0.45], '87': [45.85, 1.30],
  '88': [48.20, 6.50], '89': [47.80, 3.55], '90': [47.65, 6.90], '91': [48.55, 2.20],
  '92': [48.85, 2.25], '93': [48.95, 2.50], '94': [48.80, 2.45], '95': [49.05, 2.10],
  '971': [16.25, -61.55], '972': [14.65, -61.00], '973': [3.95, -53.10],
  '974': [-21.10, 55.55], '976': [-12.85, 45.15],
};

// Center of metropolitan France for default map view.
export const FRANCE_CENTER = [46.6, 2.45];
